<div *ngIf="spinnerIsShown"
    style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>
<div class="modal-header bg-soft-info p-3">
    <h5 class="modal-title" id="exampleModalLabel" i18n="@@">{{myfile.name}}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>
<div class="card-body p-3">
    <div class="text-center">
        <div class="profile-user position-relative avatar-lg p-1">
            <div class="avatar-title bg-light rounded-circle">
                <img src='{{getDocumentImageUrl(myfile)}}' class="avatar-md rounded-circle object-cover">
            </div>

        </div>

    </div>
</div>
<div class="card-header" style="padding-top: 10px;">
    <div class="modal-body p-0">
        <div class="step-arrow-nav">
            <ul ngbNav [(activeId)]="activeStatus" class="nav nav-pills custom-nav nav-justified" role="tablist">
                <li [ngbNavItem]="0" class="nav-item" [disabled]="true">
                    <a ngbNavLink data-bs-toggle="tab" role="tab">
                        New
                    </a>
                    <ng-template ngbNavContent>
                    </ng-template>
                </li>
                <li [ngbNavItem]="1" class="nav-item" [disabled]="true">
                    <a ngbNavLink data-bs-toggle="tab" role="tab">
                        Signed
                    </a>
                    <ng-template ngbNavContent>
                    </ng-template>
                </li>
                <li [ngbNavItem]="2" class="nav-item" [disabled]="true">
                    <a ngbNavLink data-bs-toggle="tab" role="tab">
                        Approved
                    </a>
                    <ng-template ngbNavContent>
                    </ng-template>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="card-body p-4 ">
    <div class="tab-model">
        <div class="row">
            <div class="col-lg-12 mb-3" *ngFor="let data of myfile.customFields;">
                <label for="job_type-field" class="form-label">{{data.caption}}</label>

                <div *ngIf="data.dataType == 2 else elseDropdown">
                    <div class=" input-group d-flex form-control" style="padding: 0%;">
                        <input class=" flex-grow-1 form-control" #iValue="ngModel" required style="border-width: 0;"
                            [pattern]=datePattern [disabled]="disableEditing" class="form-control" type="text"
                            [dropSpecialCharacters]="false" [(ngModel)]="data.value" placeholder="DD/MM/YYYY"
                            mask="00/00/0000" i18n-placeholder="@@" />
                        <span class=" input-group-text ri-calendar-2-line " style="border-width: 0; align-self: center;"
                            [disabled]="disableEditing" type="text" mwlFlatpickr [disableMobile]="true" [(ngModel)]="data.value"
                            [dateFormat]="'d/m/Y'"></span>
                    </div>
                </div>
                <ng-template #elseDropdown>
                    <div *ngIf="data.dataType == 19 else elseBool">
                        <select [disabled]="disableEditing" class="form-select" [(ngModel)]="data.value">
                            <option *ngFor="let key of data.keyValues">
                                {{key.key}}
                            </option>
                        </select>
                    </div>
                </ng-template>
                <ng-template #elseBool>
                    <div *ngIf="data.dataType == 17 else elseBasicInput">

                        <div class="form-check form-switch">
                            <input
                                [disabled]="disableEditing"
                                class="form-check-input" type="checkbox" [(ngModel)]="data.value" />
                        </div>

                    </div>
                </ng-template>
                <ng-template #elseBasicInput>
                    <input [disabled]="disableEditing" class="form-control" type="text"
                        placeholder="Enter {{data.caption}}" i18n-placeholder="@@" [(ngModel)]="data.value" />
                </ng-template>
            </div>
        </div>
    </div>
    <div class="row ">
        <div class="gap-2" style="display: flex; justify-content: end;">
            <div class="dropdown" ngbDropdown style="z-index: 100;  position: static;">
                <ul #actionList aria-labelledby="dropdownMenuLink1" ngbDropdownMenu>
                    <li class="p-2">
                        <button style="width: 100%;" (click)="viewMyfile()" class="btn btn-soft-primary" i18n="@@">
                            View</button>
                    </li>
                    <li class="p-2">
                        <button style="width: 100%;" (click)="printMyfile()" class="btn btn-soft-primary" i18n="@@">
                            Print</button>
                    </li>
                </ul>

                <button *ngIf="actionList.getElementsByTagName('li').length > 0" type="button" id="dropdownMenuLink1"
                    data-bs-toggle="dropdown" aria-expanded="false"
                    class="btn btn-soft-info arrow-none display: flex; justify-content: end;" ngbDropdownToggle>
                    <span i18n="@@"> Actions</span> <i class="ri-more-2-fill align-bottom"></i>
                </button>
            </div>
            <button [disabled]="btnDisabled" type="button" class="btn btn-success" id="add-btn" (click)="save()"
                i18n="@@ContactPopUp_btn_UpdateContact">Save</button>
        </div>
    </div>
</div>